import { bindingTypes, sortDirections, listTypes, LIST } from '@adalo/constants'

export const sortItems = (items, dataBinding) => {
  if (!items) {
    items = []
  }

  if (
    !dataBinding ||
    dataBinding.bindingType !== bindingTypes.LIST ||
    !dataBinding.source ||
    !dataBinding.source.sort ||
    !dataBinding.source.sort.fieldId
  ) {
    return items
  }

  // Now we know it's a list binding...
  let { sort } = dataBinding.source
  let direction = sort.direction || sortDirections.ASC
  let fieldId = sort.fieldId

  items = items.slice(0)

  let multiple = direction === sortDirections.ASC ? 1 : -1

  items.sort((item1, item2) => {
    let a = item1[fieldId]
    let b = item2[fieldId]

    if (typeof a === 'string' && typeof b === 'string') {
      a = a.toLowerCase()
      b = b.toLowerCase()
    }

    return a > b ? multiple : -multiple
  })

  return items
}

export const isListObject = obj => {
  return obj.type === LIST && obj.attributes.listType !== listTypes.GRID
}

export const listsEqual = (list1, list2) => {
  if (!list1 || !list2 || list1.length !== list2.length) {
    return false
  }

  for (let i = 0; i < list1.length; i += 1) {
    if (list1[i] !== list2[i]) {
      return false
    }
  }

  return true
}
